import { useEffect } from 'react';
import { useAppSelector } from 'services/configuration/store/hooks';
import { addSearchParams, deleteSearchParams, getSearchParam } from '../AppParams/utils';
import { isEqual } from 'lodash';
import { obliczeniaSlice } from 'services/slices/obliczeniaSlice/obliczeniaSlice'; // Import obliczeniaSlice
import { uiSlice } from 'services/slices/uiSlice'; // Import uiSlice

export const useUiUpdate = (searchParams: URLSearchParams) => {
  const { activeTab, chartType, viewMode, periodIndex } = useAppSelector(state => state.ui);
  const { selectedYear } = useAppSelector(state => state.obliczenia.obliczenia);

  useEffect(() => {
    const defaultUiState = uiSlice.getInitialState(); // Get default state for uiSlice properties
    const defaultObliczeniaState = obliczeniaSlice.getInitialState().obliczenia; // Get default state for obliczeniaSlice properties

    const currentUiState = {
      activeTab,
      chartType,
      viewMode,
      periodIndex,
      selectedYear,
    };

    const filteredUiState: Partial<typeof currentUiState> = {};

    // Compare uiSlice properties with defaultUiState
    if (!isEqual(currentUiState.activeTab, defaultUiState.activeTab)) {
      filteredUiState.activeTab = currentUiState.activeTab;
    }
    if (!isEqual(currentUiState.chartType, defaultUiState.chartType)) {
      filteredUiState.chartType = currentUiState.chartType;
    }
    if (!isEqual(currentUiState.viewMode, defaultUiState.viewMode)) {
      filteredUiState.viewMode = currentUiState.viewMode;
    }
    if (!isEqual(currentUiState.periodIndex, defaultUiState.periodIndex)) {
      filteredUiState.periodIndex = currentUiState.periodIndex;
    }

    // Compare selectedYear with its default from obliczeniaSlice
    if (!isEqual(currentUiState.selectedYear, defaultObliczeniaState.selectedYear)) {
      filteredUiState.selectedYear = currentUiState.selectedYear;
    }

    // Only add 'ui' param if there are non-default values
    if (Object.keys(filteredUiState).length > 0) {
      const existingUiStateRaw = getSearchParam('ui');
      try {
        if (existingUiStateRaw && isEqual(JSON.parse(existingUiStateRaw), filteredUiState)) {
          return; // Prevent unnecessary updates if already in URL
        }
      } catch (error) {
        // Fall through to update if parsing fails
      }
      addSearchParams(searchParams, 'ui', JSON.stringify(filteredUiState));
    } else {
      deleteSearchParams(searchParams, 'ui'); // Remove 'ui' param if all are default
    }
  }, [activeTab, chartType, viewMode, periodIndex, selectedYear, searchParams]);
};
